'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M10.696 17.21c.189 0 .342.154.342.343v1.7h1.251v.686H4.662v-.685h1.25v-1.701c0-.19.154-.343.343-.343Zm-.343.686H6.598v1.358h3.755v-1.358Zm5.024-8.517c.19 0 .343.154.343.343v.518h1.494v-.518c0-.19.154-.343.343-.343h1.492c.189 0 .343.154.343.343v.518h.087c.664 0 1.204.54 1.204 1.203v1.915h-.686v-.72h-7.06v4.83c0 .285.233.517.518.517h.41v.686h-.41c-.663 0-1.203-.54-1.203-1.204v-6.024c0-.664.54-1.203 1.203-1.203h.087v-.518c0-.19.154-.343.343-.343Zm2.615 5.96v1.485l1.135 1.135-.323.323-1.202-1.202a.229.229 0 0 1-.067-.161v-1.58h.457Zm1.085-9.067c.19 0 .343.154.343.343v1.838c0 .19-.154.343-.343.343H10.22l.01 7.728h-.685l-.002-1.774h-1.94l1.39 1.63-.349.297-1.24-1.456.002 1.303H6.72l-.01-7.728H3.344A.343.343 0 0 1 3 8.453V6.615c0-.189.154-.343.343-.343ZM9.54 12.165l-1.917 2.128h1.92l-.003-2.128Zm-.21-.45H7.4l.003 2.138 1.926-2.137Zm5.706-1.65h-.807v.517c0 .19-.153.343-.343.343h-.43a.519.519 0 0 0-.518.518v.51h7.06v-.51a.519.519 0 0 0-.518-.518h-.43a.343.343 0 0 1-.343-.343v-.517H17.9v.517c0 .19-.154.343-.343.343h-2.18a.343.343 0 0 1-.342-.343v-.517Zm-7.638-.95.003 2.143h1.929L7.397 9.114Zm2.138-.32h-1.81l1.812 2.012-.002-2.011Zm8.11-1.52-1.094.835h2.183v-.003l-1.089-.832Zm-13.96.262v.573h.75l-.75-.573Zm11.097-.262-1.092.835h2.185l-1.093-.835Zm-2.86 0-1.093.835h2.185l-1.092-.835Zm-2.861 0-1.092.835h2.184l-1.092-.835Zm-2.86 0-1.09.835h2.182l-1.092-.835Zm-.337-.317H3.686v.004l1.087.831 1.09-.835Zm11.443 0H15.12l1.093.835 1.094-.835Zm-2.863 0H12.26l1.092.835 1.092-.835Zm-2.86 0H9.399l1.092.835 1.093-.835Zm-2.86 0H6.538l1.092.835 1.092-.835Zm10.01 0h-.75l.75.574v-.574ZM8.021 3.07a.343.343 0 0 1 .313-.053l7.188 2.321-.21.653-7.018-2.267-2.91 2.214-.416-.546Z",
    fill: "#3F3E4B"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "m15.266 16.397-.671-.14a3.249 3.249 0 0 1 3.573-2.55l-.084.68a2.56 2.56 0 0 0-2.818 2.01",
    fill: "#87868F"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M21 16.918a3.24 3.24 0 0 1-3.236 3.236 3.24 3.24 0 0 1-3.236-3.236h-.841l1.183-1.182 1.182 1.182h-.839a2.552 2.552 0 0 0 5.101 0 2.555 2.555 0 0 0-2.55-2.55v-.686A3.24 3.24 0 0 1 21 16.918",
    fill: "currentColor"
  })));
});
var FwSet0Constructionyear2 = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.FwSet0Constructionyear2 = FwSet0Constructionyear2;